var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGazebo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white",
    stroke: "#4B5563"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8215 28.3215H32.5001V31.0001H7.49976V28.768H28.0357V14.4821H7.49976V12.2499C7.49976 12.2499 10.2763 12.2739 11.9641 11.8035C13.8417 11.2801 16.4284 9.57129 16.4284 9.57129",
    stroke: "black",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8221 26.5357V14.2526H32.2406V12.0539C32.2406 12.0539 28.4706 11.7728 26.2507 10.9108C24.5774 10.261 22.2328 8.67861 22.2328 8.67861H18.2148V6.44643V6H21.7863V7.3393",
    stroke: "black",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9639 14.0352V23.8567M11.9639 26.0889V23.8567M11.9639 23.8567H19.9997M19.9997 23.8567V28.7675M19.9997 23.8567H24.0176M24.0176 23.8567V26.5353M24.0176 23.8567H26.2498",
    stroke: "black",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9822 28.7686V25.6436",
    stroke: "black",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1785 28.7679V15.8213",
    stroke: "black",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8748 11.8043L19.1069 10.0186M20.4462 10.0186L21.7855 11.3579H23.1248V12.2507",
    stroke: "black",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGazebo);
export default __webpack_public_path__ + "static/media/Gazebo.01f3755ad29d50218176dea7a213f532.svg";
export { ForwardRef as ReactComponent };